import React from 'react';
import { Search, X } from 'lucide-react';

function ListToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search…',
  filters,
  viewToggle,
  children,
}) {
  return (
    <div className="ux-list-toolbar">
      {searchValue !== undefined && (
        <div className="ux-list-search">
          <Search size={18} className="ux-list-search-icon" />
          <input
            type="search"
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            placeholder={searchPlaceholder}
            aria-label="Search list"
          />
          {searchValue && (
            <button type="button" className="ux-list-search-clear" onClick={() => onSearchChange?.('')} aria-label="Clear search">
              <X size={16} />
            </button>
          )}
        </div>
      )}
      {filters && <div className="ux-list-filters">{filters}</div>}
      {viewToggle && <div className="ux-list-view-toggle">{viewToggle}</div>}
      {children}
    </div>
  );
}

export default ListToolbar;
